import React, { Fragment, useEffect } from "react"
import ReactDOM from "react-dom"
import { select, svg } from "d3"

import {
    chartHeight,
    getRegionColor,
    regionColors,
    regioniPathMap,
    usingExplorer
} from "../../utility/Utility"
import Macroregionisvg from "./macroregioni.svg"

const titles: { [key: string]: string } = {
    numeroAddetti: "Distribuzione territoriale degli Addetti",
    numeroPosizioni: "Distribuzione territoriale delle Posizioni",
    redditi: "Redditi medi",
    ricaviCompensi: "Ricavi/Compensi medi",
    punteggioIsaAnomalie: "Punteggio ISA"
}

interface ChartRegioniProps {
    datiRegionali: any
    datiGrafico: any
    dataType: string
}

interface LegendProps {
    colors: string[]
    labels: string[]
    counts: string[]
}

const Legend = ({ colors, labels, counts }: LegendProps) => {
    return (
        <>
            <text
                x={0}
                y={110}
                fill={"black"}
                textAnchor="start"
                fontSize={22}
                fontWeight="bold"
                alignmentBaseline="middle"
            >
                Legenda:
            </text>
            {labels.map((label, i) => {
                return (
                    <Fragment key={i}>
                        <rect
                            x={120}
                            y={100 + i * 25}
                            fill={colors[i]}
                            width={30}
                            height={20}
                        ></rect>
                        <text
                            x={160}
                            y={100 + i * 25 + 20 / 2}
                            fill={"black"}
                            textAnchor="start"
                            fontSize={18}
                            alignmentBaseline="middle"
                        >
                            {label} {`[${counts[i]}]`}
                        </text>
                    </Fragment>
                )
            })}
        </>
    )
}

const ChartRegioni = ({
    datiRegionali,
    datiGrafico,
    dataType
}: ChartRegioniProps) => {
    const { elementiRegionali } = datiRegionali
    const addSizeExplorer = usingExplorer() ? 25 : 0

    useEffect(() => {
        let svgRegioni = undefined

        const dataTypeMapper: { [key: string]: string } = {
            numeroAddetti: "NUM_ADDETTI",
            numeroPosizioni: "NUM_POSIZIONI",
            redditi: "REDD_DIC",
            ricaviCompensi: "RIC_COMP_DIC",
            punteggioIsaAnomalie: "PUNTEGGIO_ISA_ANOM"
        }
        const dataTypeMapped = dataTypeMapper[dataType]

        const grafico = datiGrafico
            ?.filter((g: any) => g.datoAnalizzato === dataTypeMapped)
            .sort((a: any, b: any) => a.fasciaPercentile - b.fasciaPercentile)

        if (elementiRegionali !== undefined && elementiRegionali !== null) {
            svg(Macroregionisvg).then((data: any) => {
                const container = select<Element, unknown>(`#region_chart_container_${dataType}`)
                //console.log(data);
                container?.node()?.appendChild(data.documentElement)
                svgRegioni = container.select(`svg`)

                svgRegioni
                    .attr("id", `region_chart_${dataType}`)
                    .attr("class", "region_chart");

                svgRegioni
                    .insert("text")
                    .attr(
                        "transform",
                        `translate(${567.394 + addSizeExplorer},30)`
                    )
                    .attr("font-size", "26")
                    .attr("text-anchor", "middle")
                    .attr("font-weight", "bold")
                    .text(titles[dataType])

                for (let i = 0; i < elementiRegionali?.length - 1; i++) {
                    const regione = elementiRegionali[i]
                    let valore = regione[dataType] !== '***' ? regione[dataType]
                        .replace(/\./g, "")
                        .replace(/,/g, ".") : '0'

                    let color = getRegionColor(Number(valore), dataType, [
                        ...new Set<string>(
                            grafico.map((e: any) => e.descFasciaPercentile)
                        )
                    ])
                    let elementId = regioniPathMap[regione.regione]


                    if (elementId.startsWith("g")) {
                        svgRegioni
                            .select("#layer4")
                            .select(`#${elementId}`)
                            .selectAll("path")
                            .attr("fill", color)
                    } else {
                        svgRegioni
                            .select("#layer4")
                            .select(`#${elementId}`)
                            .attr("fill", color)
                    }
                }

                let legend = svgRegioni
                    .insert("g")
                    .attr("transform", `translate(${700}, 100)`)

                let countValues: any[] = []
                grafico.forEach(function (item: any) {
                    var i = countValues.findIndex(
                        (x) =>
                            x.fasciaPercentile === item.fasciaPercentile &&
                            x.descFasciaPercentile === item.descFasciaPercentile
                    )
                    if (i <= -1) {
                        countValues.push(item)
                    }
                    return null
                })
                ReactDOM.render(
                    <Legend
                        colors={regionColors[dataType]}
                        labels={[
                            ...new Set<string>(
                                grafico.map(
                                    (e: { descFasciaPercentile: string }) =>
                                        e.descFasciaPercentile
                                )
                            )
                        ]}
                        counts={countValues.map((e) => e.countRegFascPerc)}
                    />,
                    legend.node()
                )
            })
        }
        return () => {}
    }, [elementiRegionali, addSizeExplorer, dataType, datiGrafico])

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                ...chartHeight(750)
            }}
            id={`region_chart_container_${dataType}`}
        ></div>
    )
}
export default ChartRegioni
